import { render, staticRenderFns } from "./UtilSPLanding.vue?vue&type=template&id=82fa66ac&scoped=true"
import script from "./UtilSPLanding.vue?vue&type=script&lang=js"
export * from "./UtilSPLanding.vue?vue&type=script&lang=js"
import style0 from "./UtilSPLanding.vue?vue&type=style&index=0&id=82fa66ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fa66ac",
  null
  
)

export default component.exports